module.exports = __webpack_public_path__ + "static/media/italy.f09d7c1a.png";